import { merge } from 'lodash'
import Noty from 'noty'
import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui'

Noty.overrideDefaults({
  layout: 'topRight',
  theme: 'relax',
  animation: {
    open: function (promise) {
      Velocity(this.barDom, 'transition.slideRightIn', {
        duration: 300,
        complete () {
          promise(function (resolve) {
            resolve()
          })
        }
      })
    },
    close: function (promise) {
      Velocity(this.barDom, 'transition.slideRightOut', {
        duration: 300,
        complete () {
          promise(function (resolve) {
            resolve()
          })
        }
      })
    }
  }
})

export default {
  /**
  * Default notification method.
  *
  * @param object options
  *
  * @return Noty
  */
  notification (options) {
    const defaults = {
      timeout: 3000
    }

    try {
      return new Noty(merge(defaults, options)).show()
    } catch (error) {
      // Fail silently if Noty throws an exception...
    }
  },

  /**
  * Create a success notification.
  *
  * @param string text
  *
  * @return Noty
  */
  success (text) {
    return this.notification({ text, type: 'success' })
  },

  /**
  * Create a info notification.
  *
  * @param string text
  *
  * @return Noty
  */
  info (text) {
    return this.notification({ text, type: 'info' })
  },

  /**
  * Create an error notification.
  *
  * @param string text
  *
  * @return Noty
  */
  error (text) {
    return this.notification({ text, type: 'error' })
  },

  /**
  * Create a warning notification.
  *
  * @param string text
  *
  * @return Noty
  */
  warning (text) {
    return this.notification({ text, type: 'warning' })
  }
}
